import { render, staticRenderFns } from "./ItemCategoriesListFilters.vue?vue&type=template&id=2fa54320"
import script from "./ItemCategoriesListFilters.vue?vue&type=script&lang=js"
export * from "./ItemCategoriesListFilters.vue?vue&type=script&lang=js"
import style0 from "./ItemCategoriesListFilters.vue?vue&type=style&index=0&id=2fa54320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports